// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"755":"5c83305a","842":"8afedaea"}[chunkId] + ".chunk.js";
};